/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
// utils/sanitize.ts
// utils/sanitize.ts
export const sanitizeEmailInput = (value: string): string => {
	value = value.replace(/^\s+/, ''); // leading
	value = value.replace(/\s+$/, ''); // trailing
	value = value.replace(/\s/g, ''); // anywhere
	return value;
};
